module.exports = __webpack_public_path__ + "static/ASCOVIME - DawaCoordinator Registers Patient 2_2019-4759e44e0a05c403f0d8456e1c5d907e.jpg";